import { render, staticRenderFns } from "./Requisits.vue?vue&type=template&id=c78094ea&scoped=true&"
import script from "./Requisits.vue?vue&type=script&lang=js&"
export * from "./Requisits.vue?vue&type=script&lang=js&"
import style0 from "./Requisits.vue?vue&type=style&index=0&id=c78094ea&scoped=true&lang=css&"
import style1 from "./Requisits.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78094ea",
  null
  
)

export default component.exports